<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button @click="$utils.goBack($router)"   text="Quay lại" defaultHref="/tabs/main"></ion-back-button>
        </ion-buttons>
        <ion-title>Kết quả</ion-title>
        <ion-label slot="end" style="margin-right: 2vw"></ion-label>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <GameTitle game="xskt"></GameTitle>
      <Construction></Construction>
    </ion-content>
  </ion-page>

</template>

<script>
  import GameTitle from '@/components/GameTitle';
  import Construction from '@/components/Construction.vue'
  import { defineComponent } from 'vue';
  import {
    IonPage,
    IonContent,
    IonHeader,
    IonButtons,
    IonBackButton,
    IonTitle,
    IonToolbar,
    IonLabel,
  } from '@ionic/vue';

  export default defineComponent({
    components: {
      IonPage,
      IonContent,
      IonHeader,
      IonButtons,
      IonBackButton,
      IonTitle,
      IonToolbar,
      GameTitle,
      Construction,
      IonLabel,
    },
  })
</script>

